import { render, staticRenderFns } from "./Famous-historical.vue?vue&type=template&id=6e67d86c&scoped=true"
import script from "./Famous-historical.vue?vue&type=script&lang=js"
export * from "./Famous-historical.vue?vue&type=script&lang=js"
import style0 from "./Famous-historical.vue?vue&type=style&index=0&id=6e67d86c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67d86c",
  null
  
)

export default component.exports